import Images from "../Assets/Images";
import CountUp from "./CountUp";
import {Link} from "react-router-dom";


export default function Personal () {
    return(
        <div>
            <section className="flex flex-col gap-4">
                <div className="flex flex-col md:flex-row items-center justify-center gap-4">
                    <img
                        src={Images.Personal.headshot2.src}
                        alt="headshot"
                        className="w-36 h-36 md:w-48 md:h-48 rounded-full object-cover object-top shadow-lg"
                    />
                    <div className="w-[290px]">
                        <p>
                            Solving a rubix cube in <strong><CountUp from={999} to={99}/></strong> seconds
                        </p>
                        <p>
                            Chess rating peaked at <strong><CountUp from={600} to={1800} duration={1} /></strong>
                        </p>
                        <p>
                            Love to play basketball and swim
                        </p>
                    </div>
                </div>
            </section>
            {/* Talk */}
            <p className="mt-10 px-2">Outside of coding, I like to unwind by playing piano or sports like basketball. Staying active helps me clear my head and balance out all the sitting that comes with being a dev.<br/> I used to chase money, but life taught me time is the real currency. I’m still figuring out my purpose, but I do know I want to leave things better than I found them.</p>

            {/* Hobbies / Interests Section */}
            <section>
                <h2 className="text-2xl sm:text-3xl font-semibold mb-2 mt-10 text-center">
                    Hobbies & Interests
                </h2>
                <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-gray-700 text-sm sm:text-base">
                    <span>🏀 Basketball</span>
                    <span>🏊 Swimming</span>
                    <span>🏂 Snowboarding</span>
                    <span>🎹 Piano</span>
                    <span>🏍️ Motorcycle riding</span>
                    <span>♟️ Chess</span>
                </div>
            </section>


            {/* Contact CTA */}
            <section className="text-center mt-12">
                <Link
                    to="/contact"
                    className="px-6 py-3 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-500 transition"
                >
                    Get in Touch
                </Link>
            </section>

        </div>
    )

}